import { render } from "./vue-file-agent.vue?vue&type=template&id=fabdc240&scoped=true&ts=true"
import script from "./vue-file-agent.vue?vue&type=script&lang=ts"
export * from "./vue-file-agent.vue?vue&type=script&lang=ts"

import "./vue-file-agent.vue?vue&type=style&index=0&id=fabdc240&scoped=true&lang=css"

import exportComponent from "../../../../../../../ss/CO/ui/NibrsRepository/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabdc240"]])

export default __exports__